import React from 'react';
import { GlobalHotKeys } from 'react-hotkeys';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import pmp from '../../static/images/pmp.gif';

const KEY_MAP = {
  SHOW_PMP: 'p m p',
};

const useStyles = makeStyles(_theme => ({
  root: {},
}));

export type KeymapHelpClasses = GetClasses<typeof useStyles>;

export const PMP = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const onClose = () => {
    setIsOpen(false);
  };

  const HANDLERS = {
    SHOW_PMP: () => setIsOpen(true),
  };

  return (
    <>
      <GlobalHotKeys keyMap={KEY_MAP} handlers={HANDLERS}>
        <span />
      </GlobalHotKeys>
      <Modal
        fullWidth
        isOpen={isOpen}
        title="Precision Medicine Platform"
        onDismiss={onClose}
      >
        <img alt="" src={pmp} />
      </Modal>
    </>
  );
};
